import Swal from 'sweetalert2'

import { fetchConToken } from "../helpers/fetch";
import { types } from "../types/types";



export const sellStartAddNew= ( order ) => {

  
    return async(dispatch ,getState) => {

        const { uid, name } = getState().auth

        try {

            const newOrder = {
                tramite: order.id,
                items: order.additional_info.items,
                estado: "pendiente",
                usuario:{
                    id: uid,
                    name
                },
                mpResponse: {...order}
            }

            const resp = await fetchConToken('ventas',newOrder,'POST');
            const body = await resp.json();
            
  
            dispatch( sellAddNew( newOrder ) )

        } catch (error) {
            console.log(error)
        }


       
    }
}


 const sellAddNew= ( order ) => ({
    type: types.sellAddNew,
    payload: order
})

export const sellStartLoading = () => {
    return async(dispatch,getState) =>{

        const { acces,uid } = await getState().auth

       try {
            const resp = await fetchConToken('ventas')
            const body = await resp.json()

            if(body.ok && acces === "admin"){
                dispatch(sellLoaded(body.ventas))
                
            }else if(body.ok && acces !== "admin"){

                const userSell = []

                body.ventas.map(venta =>{

                    if(uid === venta.usuario.id){
                      userSell.push({
                         tramite: venta.tramite,
                         usuario: venta.usuario,
                         items:venta.items,
                         estado: venta.estado
                      })
                    }
                  
                })

              await  dispatch(sellLoaded(userSell))

            }
            // const product = body.products

            // dispatch(productLoaded(product))
           
       } catch (error) {
           console.log(error)
       }

    }
}


const sellLoaded = ( sells )=>({
    type: types.sellLoaded,
    payload: sells
})

export const sellStartUpdate = ( venta ) => {
    return async(dispatch) => {

       
        try {
             const resp = await fetchConToken(`ventas/${ venta.id }`,venta,'PUT');
             const body = await resp.json();

             if(body.ok){
                 dispatch(sellUpdated(venta))
             }else{
                Swal.fire('Error',body.msg,'error')
             }
            
        } catch (error) {
            console.log(error)
        }

    }
}


const sellUpdated = ( venta ) =>({
    type: types.sellUpdate,
    payload: venta
})

export const sellStartDeleted = (venta) =>{
    return async(dispatch) =>{

        try {
            
            const resp = await fetchConToken( `ventas/${ venta.id }`, {}, 'DELETE' );
            const body = await resp.json();

            if(body.ok){
                dispatch(ventaDeleted(venta))
            }else{
               Swal.fire('Error',body.msg,'error')
            }
           
            
        } catch (error) {
            console.log(error)
        }

    }
}
 const ventaDeleted = ( venta ) =>({
    type: types.sellDelete,
    payload: venta
})


